import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { UiFormModule } from '../../../shared/ui/ui-form.module';
import { FinancingDetailPanelComponent } from './financing-detail-panel.component';
import { FinancingFormDialogComponent } from './financing-form-dialog/financing-form-dialog.component';

@NgModule({
  declarations: [
    FinancingDetailPanelComponent,
    FinancingFormDialogComponent,
  ],
  exports: [
    FinancingDetailPanelComponent,
    FinancingFormDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    UiFormModule,
  ],
})
export class FinancingDetailModule { }
